import { Select } from '../../../shared/components';
import { ParamUser, ParamActivity } from '../../../shared/services/settings/types';
import { Novedad } from '../../../shared/services/operationTimes/types';

export interface FiltersState {
  userId: string;
  activityId: string;
  dateFrom: string;
  dateTo: string;
  novedad: Novedad | '';
}

interface ActivityFiltersProps {
  value: FiltersState;
  onChange: (value: FiltersState) => void;
  users: ParamUser[];
  activities: ParamActivity[];
  /**
   * Si viene, el filtro de Usuario queda deshabilitado y fijo en esta persona.
   * Control de Tiempos es una pantalla PERSONAL: nadie puede ver los registros
   * de otro colaborador aqui (para eso existen Reportes y Auditoria, que si
   * permiten filtrar por cualquier usuario).
   */
  lockUserFilter?: boolean;
}

const NOVEDAD_OPTIONS = [
  { value: 'modified', label: 'Modificado' },
  { value: 'deleted', label: 'Borrado' },
];

/** Filtro de historial: por usuario, fecha, actividad y Novedad (Modificado/Borrado). */
export function ActivityFilters({ value, onChange, users, activities, lockUserFilter }: ActivityFiltersProps) {
  const update = (patch: Partial<FiltersState>) => onChange({ ...value, ...patch });

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-5">
      <Select
        placeholder="Todos los usuarios"
        options={users.map((u) => ({ value: u.id, label: u.fullName }))}
        value={value.userId}
        onChange={(e) => update({ userId: e.target.value })}
        disabled={!!lockUserFilter}
        title={lockUserFilter ? 'En Tiempos solo puedes ver tus propios registros. Usa Reportes o Auditoría para ver los de otros colaboradores.' : undefined}
        className={lockUserFilter ? 'cursor-not-allowed opacity-70' : undefined}
      />
      <Select
        placeholder="Todas las actividades"
        options={activities.map((a) => ({ value: a.id, label: a.name }))}
        value={value.activityId}
        onChange={(e) => update({ activityId: e.target.value })}
      />
      <label className="block">
        <input
          type="date"
          value={value.dateFrom}
          onChange={(e) => update({ dateFrom: e.target.value })}
          className="h-[50px] w-full rounded-xl border border-ink-200 bg-surface px-3 text-sm outline-none focus:ring-2 focus:ring-brand-200"
        />
      </label>
      <label className="block">
        <input
          type="date"
          value={value.dateTo}
          onChange={(e) => update({ dateTo: e.target.value })}
          className="h-[50px] w-full rounded-xl border border-ink-200 bg-surface px-3 text-sm outline-none focus:ring-2 focus:ring-brand-200"
        />
      </label>
      <Select
        placeholder="Novedad: todas"
        options={NOVEDAD_OPTIONS}
        value={value.novedad}
        onChange={(e) => update({ novedad: e.target.value as Novedad | '' })}
      />
    </div>
  );
}
